import React from 'react';
import { Table, Tag } from 'rsuite';
import PropTypes from 'prop-types';
import { get, getOr, isArray, toUpper } from 'lodash/fp';

const { Cell } = Table;

export const StatusCell = ({ rowData, dataKey, ...props }) => (
  <Cell {...props} className="link-group">
    {rowData[dataKey] === 1 ? (
      <Tag color="green" size="lg">
        &#10004; Success
      </Tag>
    ) : (
      <Tag color="red" size="lg">
        &#x2716; Failed
      </Tag>
    )}
  </Cell>
);

StatusCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({})
};

StatusCell.defaultProps = {
  rowData: null
};

export const MessageCell = ({ rowData, dataKey, ...props }) => {
  const errors = get('error', rowData[dataKey]);
  const action = getOr('saved', 'action', rowData);
  return (
    <Cell {...props}>
      {isArray(errors) ? (
        <div style={{ color: 'red' }}>
          <p>ERROR:</p>
          {errors.map(({ message }, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <p key={`item-${i}`}> - {message}</p>
          ))}
        </div>
      ) : (
        getOr(toUpper(action), 'message', rowData[dataKey])
      )}
    </Cell>
  );
};

MessageCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({})
};

MessageCell.defaultProps = {
  rowData: null
};
